import { useCallback, useMemo } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { SUPPORT_AGENTS, supportAgentName } from "../../../constants/supportAgents";

// Les ids renvoyés par la support-api (requesterId, senderId, assigneeId, actorId…) sont des `sub` Keycloak.
// Résolution locale : agent connecté, puis liste SUPPORT_AGENTS, sinon id tronqué.
export const useSupportPeople = () => {
  const { keycloak } = useKeycloak();
  const me = keycloak?.tokenParsed || {};
  const myId = me.sub;
  const myName = me.name || me.preferred_username || me.email || "Moi";

  const personName = useCallback(
    (id) => {
      if (!id) return null;
      if (id === myId) return `${myName} (moi)`;
      return supportAgentName(id) || `${id.slice(0, 8)}…`;
    },
    [myId, myName]
  );

  const assigneeOptions = useMemo(
    () => [
      ...(myId ? [{ id: myId, name: `${myName} (moi)` }] : []),
      ...SUPPORT_AGENTS.filter((a) => a.id !== myId),
    ],
    [myId, myName]
  );

  return { myId, myName, personName, assigneeOptions };
};
